import { createRouter as createVueRouter, createWebHistory, Router } from "vue-router";
import Home from "../views/Home.vue";
import WorkOrders from "../views/WorkOrders.vue";
import UpdateOrder from "../views/UpdateOrder.vue";
import StoreDisable from "../views/StoreDisable.vue";

import DVIWorkOrders from "../views/DVIWorkOrders.vue";
import DVIWorkOrderPackages from "../views/DVIWorkOrderPackages.vue";
import DVISummaryWorkOrderPackage from "../views/DVISummaryWorkOrderPackage.vue";
import DVIUpdateWorkOrderPackage from "../views/DVIUpdateWorkOrderPackage.vue";

import Reporting from "../views/Reporting.vue";
import ReportingV3 from "../views/ReportingV3.vue";
import Reports from "../views/Reports.vue";
import FrozenColumnTest from "@/views/FrozenColumnTest.vue";
import Enterprise from "../views/Enterprise.vue";
import DVIResults from "../views/DVIResults.vue";

import { createAuthGuard } from "@auth0/auth0-vue";
import { App } from 'vue';

export function createRouter(app: App): Router {
  return createVueRouter({
    routes: [
      {
        path: "/",
        name: "home",
        component: Home
      },
      {
        path: "/workorders",
        name: "workorders",
        component: WorkOrders,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/updateorder",
        name: "updateorder",
        component: UpdateOrder,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/storedisable",
        name: "storedisable",
        component: StoreDisable,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/dviworkorders",
        name: "dviworkorders",
        component: DVIWorkOrders,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/dviworkorderpackages",
        name: "dviworkorderpackages",
        component: DVIWorkOrderPackages,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/dviupdateworkorderpackage",
        name: "dviupdateworkorderpackage",
        component: DVIUpdateWorkOrderPackage,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/dvisummaryworkorderpackage",
        name: "dvisummaryworkorderpackage",
        component: DVISummaryWorkOrderPackage,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/reportingV3",
        name: "reportingV3",
        component: ReportingV3,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/reporting",
        name: "reporting",
        component: Reporting,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/reports",
        name: "reports",
        component: Reports,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/FrozenColumnTest",
        name: "FrozenColumnTest",
        component: FrozenColumnTest,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/enterprise",
        name: "enterprise",
        component: Enterprise,
        beforeEnter: createAuthGuard(app)
      },
      {
        path: "/results.html",
        name: "dviresults",
        component: DVIResults
      },
    ],
    history: createWebHistory()
  });
}
